import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, UserPlus, Download, Eye, Mail, MoreVertical, ArrowLeft, Filter } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
import { Avatar, AvatarFallback } from '../../components/ui/Avatar';
export function ChapterMembers() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const members = [{
    id: 1,
    name: 'Ahmad Rizki',
    email: 'ahmad@example.com',
    role: 'Anggota',
    status: 'Aktif',
    joined: '15 Jan 2024',
    events: 5
  }, {
    id: 2,
    name: 'Siti Rahayu',
    email: 'siti@example.com',
    role: 'Anggota',
    status: 'Aktif',
    joined: '20 Feb 2024',
    events: 3
  }, {
    id: 3,
    name: 'Budi Hartono',
    email: 'budi@example.com',
    role: 'Anggota',
    status: 'Tidak Aktif',
    joined: '10 Mar 2024',
    events: 1
  }, {
    id: 4,
    name: 'Dewi Lestari',
    email: 'dewi@example.com',
    role: 'Anggota',
    status: 'Aktif',
    joined: '5 Apr 2024',
    events: 7
  }];
  const filteredMembers = members.filter(member => {
    const matchesSearch = member.name.toLowerCase().includes(searchQuery.toLowerCase()) || member.email.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || member.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  const handleExport = () => {
    alert('Mengekspor daftar anggota...');
  };
  const handleAddMember = () => {
    navigate('/chapter/members/add');
  };
  const handleSendEmail = (email: string) => {
    alert(`Mengirim email ke ${email}`);
  };
  return <div className="min-h-screen bg-white" data-id="element-1437">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1438">
        {/* Header */}
        <div className="mb-8" data-id="element-1439">
          <Button variant="ghost" onClick={() => navigate('/chapter/dashboard')} className="mb-4" data-id="element-1440">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1441" />
            Kembali ke Dasbor
          </Button>
          <div className="flex items-center justify-between" data-id="element-1442">
            <div data-id="element-1443">
              <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-1444">
                Anggota Chapter
              </h1>
              <p className="text-neutral-600" data-id="element-1445">
                Kelola anggota di Jakarta Tech Community
              </p>
            </div>
            <div className="flex gap-3" data-id="element-1446">
              <Button variant="secondary" onClick={handleExport} data-id="element-1447">
                <Download className="w-4 h-4 mr-2" data-id="element-1448" />
                Export
              </Button>
              <Button onClick={handleAddMember} data-id="element-1449">
                <UserPlus className="w-4 h-4 mr-2" data-id="element-1450" />
                Tambah Anggota
              </Button>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-1451">
          {[{
          label: 'Total Anggota',
          value: members.length
        }, {
          label: 'Aktif',
          value: members.filter(m => m.status === 'Aktif').length
        }, {
          label: 'Tidak Aktif',
          value: members.filter(m => m.status === 'Tidak Aktif').length
        }, {
          label: 'Bulan Ini',
          value: '12'
        }].map((stat, i) => <Card key={i} data-id="element-1452">
              <CardContent className="p-6" data-id="element-1453">
                <p className="text-2xl font-semibold text-neutral-900" data-id="element-1454">
                  {stat.value}
                </p>
                <p className="text-sm text-neutral-600" data-id="element-1455">{stat.label}</p>
              </CardContent>
            </Card>)}
        </div>

        {/* Filters */}
        <Card className="mb-6" data-id="element-1456">
          <CardContent className="p-6" data-id="element-1457">
            <div className="flex flex-col md:flex-row gap-4" data-id="element-1458">
              <div className="flex-1 relative" data-id="element-1459">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" data-id="element-1460" />
                <Input className="pl-10" placeholder="Cari nama atau email..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1461" />
              </div>
              <select className="h-9 rounded-lg border border-neutral-300 bg-white px-4 text-sm" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-1462">
                <option value="all" data-id="element-1463">Semua Status</option>
                <option value="Aktif" data-id="element-1464">Aktif</option>
                <option value="Tidak Aktif" data-id="element-1465">Tidak Aktif</option>
              </select>
            </div>
          </CardContent>
        </Card>

        {/* Table */}
        <Card data-id="element-1466">
          <CardContent className="p-0" data-id="element-1467">
            <Table data-id="element-1468">
              <TableHeader data-id="element-1469">
                <TableRow data-id="element-1470">
                  <TableHead className="w-[50px]" data-id="element-1471"></TableHead>
                  <TableHead data-id="element-1472">Nama</TableHead>
                  <TableHead data-id="element-1473">Email</TableHead>
                  <TableHead data-id="element-1474">Status</TableHead>
                  <TableHead data-id="element-1475">Acara Diikuti</TableHead>
                  <TableHead data-id="element-1476">Bergabung</TableHead>
                  <TableHead className="text-right" data-id="element-1477">Aksi</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-1478">
                {filteredMembers.map(member => <TableRow key={member.id} data-id="element-1479">
                    <TableCell data-id="element-1480">
                      <Avatar size="sm" data-id="element-1481">
                        <AvatarFallback data-id="element-1482">
                          {member.name.substring(0, 2).toUpperCase()}
                        </AvatarFallback>
                      </Avatar>
                    </TableCell>
                    <TableCell className="font-medium text-neutral-900" data-id="element-1483">
                      {member.name}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-1484">
                      {member.email}
                    </TableCell>
                    <TableCell data-id="element-1485">
                      <Badge variant={member.status === 'Aktif' ? 'success' : 'default'} data-id="element-1486">
                        {member.status}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-neutral-900" data-id="element-1487">
                      {member.events}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-1488">
                      {member.joined}
                    </TableCell>
                    <TableCell className="text-right" data-id="element-1489">
                      <div className="flex justify-end gap-2" data-id="element-1490">
                        <Button size="sm" variant="ghost" onClick={() => navigate(`/chapter/members/${member.id}`)} data-id="element-1491">
                          <Eye className="w-4 h-4" data-id="element-1492" />
                        </Button>
                        <Button size="sm" variant="ghost" onClick={() => handleSendEmail(member.email)} data-id="element-1493">
                          <Mail className="w-4 h-4" data-id="element-1494" />
                        </Button>
                        <Button size="sm" variant="ghost" data-id="element-1495">
                          <MoreVertical className="w-4 h-4" data-id="element-1496" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        {filteredMembers.length === 0 && <div className="text-center py-12" data-id="element-1497">
            <UserPlus className="w-16 h-16 text-neutral-300 mx-auto mb-4" data-id="element-1498" />
            <h3 className="text-lg font-semibold text-neutral-900 mb-2" data-id="element-1499">
              Tidak ada anggota ditemukan
            </h3>
            <p className="text-neutral-600" data-id="element-1500">
              Coba ubah filter atau kata kunci pencarian
            </p>
          </div>}

        {/* Pagination */}
        <div className="flex items-center justify-between mt-6" data-id="element-1501">
          <p className="text-sm text-neutral-600" data-id="element-1502">
            Menampilkan 1-{filteredMembers.length} dari {members.length} anggota
          </p>
          <div className="flex gap-2" data-id="element-1503">
            <Button variant="secondary" disabled data-id="element-1504">
              Sebelumnya
            </Button>
            <Button variant="secondary" data-id="element-1505">Selanjutnya</Button>
          </div>
        </div>
      </div>
    </div>;
}